import { FC } from 'react';
import { ListShape } from '../QuickForm.enums';
import { CardMapperProps } from '../QuickForm.types';
import CardAsset from './CardAsset';
import CardColumn from './CardColumn';
import CardInvitee from './CardInvitee';
import CardRow from './CardRow';

const CardsMapper: FC<CardMapperProps> = ({
  card,
  handleRemoveItem,
  disabled,
}) => {
  switch (card.listShape) {
    case ListShape.listColumn:
      return (
        <CardColumn
          item={ card.item }
          handleRemoveItem={ handleRemoveItem }
          disabled={ disabled }
        />
      );
    case ListShape.listRow:
      return (
        <CardRow
          item={ card.item }
          handleRemoveItem={ handleRemoveItem }
          disabled={ disabled }
        />
      );
    case ListShape.listAsset:
      return (
        <CardAsset
          item={ card.item }
          handleRemoveItem={ handleRemoveItem }
          disabled={ disabled }
        />
      );
    case ListShape.listInvitee:
      return (
        <CardInvitee
          item={ card.item }
          handleRemoveItem={ handleRemoveItem }
          disabled={ disabled }
        />
      );
    default:
      return null;
  }
};

export default CardsMapper;
